<div class="page-header">
  <div class="header-start">
    <h3 class="title">List Of Customers</h3>
  </div>
  <div class="header-end">
    <ng-select permissions resourceName="CUSTOMER" permission="EDIT" class="ng-select-toolbar"
      name="customerName" [items]="customerNamesWithIds" [loading]="isSearchResultLoading" [multiple]="true"
      [closeOnSelect]="false" [clearSearchOnAdd]="true" (clear)="setCutomerList()" bindLabel="customerName" bindValue="customerId"
      placeholder="Search Customers" [(ngModel)]="selectedCustomers" (input)="onCustomerNameEntered($event)"
      (change)="onCustomerSelected()">

      <ng-template ng-option-tmp let-item="item" let-item$="item$">
        <ng-container *ngIf="item$.selected else emptyCheck">
          <i class="far fa-check-square"></i>
        </ng-container>
        <ng-template #emptyCheck>
          <i class="far fa-square"></i>
        </ng-template>
        &nbsp;{{item.customerName}}
      </ng-template>

      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div class="ng-value" *ngFor="let item of items | slice:0:1">
          <span class="ng-value-label"> {{assertUserData(item).customerName}}</span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </div>
        <div class="ng-value" *ngIf="items.length > 1">
          <span class="ng-value-label">{{items.length - 1}} more...</span>
        </div>
      </ng-template>
    </ng-select>


    <button *ngIf="isEditPermission" permissions resourceName="CUSTOMER" permission="EDIT" mat-raised-button
      color="primary" (click)="addCustomerPage()">
      <i class="fas fa-plus mr-2"></i> Add Customer
    </button>
  </div>
</div>

<div class="position-relative mb-3">
  <spinner [id]="'customer-list-data'" [show]='loading'></spinner>
  <lib-data-table tableType="dataTable" tableId=customerlist [tableConfig]="tableConfig" [data]="tableData"
    (optionsClick)="handleOptionClick($event)" [clickableDataTypes]="dataTypes" [customTemplates]="{'status': status}">
  </lib-data-table>
  <ng-template #status let-rowData="rowData" let-index="index">
    <td (click)="handleRowClick(rowData,index)">
      <span class="font-weight-bold text-success">{{rowData[index]?.values[0]}}</span>
    </td>
  </ng-template>
</div>